import React, { FC } from 'react';

import { Box } from '@mui/material';

import { IMatchingAvailabilityChildren, TimeFormat } from '@pharmaplan/common';

import { IDynamicTableObject } from '../../../DynamicTable/types';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { DynamicTableCell } from '../../../../helpers/Constants';
import { resetDialog } from '../../../../reducers/dialogReducer';
import { getDayMonthDateYear } from '../../../Reports/helpers';
import { timeString } from '../../../../helpers/Functions';
import CustomButton from '../../../common/CustomButton';
import DynamicTable from '../../../DynamicTable';
import strings from '../../../../localization';

import styles from './styles';

interface IMatchingAvailabilityModal {
  data: Array<IMatchingAvailabilityChildren>;
  name: string;
}

const MultiDayAvailabilityModal: FC<IMatchingAvailabilityModal> = ({
  data,
  name,
}) => {
  const dispatch = useAppDispatch();

  const rows = data?.map((item) => {
    const { availableTimeId, startDate, endDate } = item;
    const date = getDayMonthDateYear(startDate);
    const time = timeString(startDate, endDate, TimeFormat.twentyFourHours);

    return {
      key: availableTimeId,
      data: [
        {
          key: `1-${availableTimeId}`,
          value: date,
          type: DynamicTableCell.text,
        },
        {
          key: `2-${availableTimeId}`,
          value: time,
          type: DynamicTableCell.text,
        },
      ],
    };
  });

  const headers = [
    { key: '1', label: strings.date },
    { key: '2', label: strings.time },
  ];

  const table: IDynamicTableObject = {
    rows,
    title: name,
    headers,
    headerBar: [],
  };

  const handleClose = () => {
    dispatch(resetDialog());
  };

  return (
    <Box sx={styles.container}>
      <DynamicTable
        table={table}
        loadSuccess
        hidePagination
        customFooter={(
          <Box sx={styles.buttonContainer}>
            <CustomButton label={strings.close} onClick={handleClose} />
          </Box>
        )}
      />
    </Box>
  );
};

export default MultiDayAvailabilityModal;
